// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { z } from 'zod';

export const assetFunctionalStatusSchema = z.enum([
  'FUNCTIONAL',
  'NEEDS_REVIEW',
  'NON_FUNCTIONAL',
  'SCRAPPED',
]);

export type AssetFunctionalStatus = z.infer<typeof assetFunctionalStatusSchema>;

// Links and saved filters may spell a status in any case, with a dash for an underscore.
export const assetFunctionalStatusFilterSchema = z.preprocess(
  (value) =>
    typeof value === 'string'
      ? value.toUpperCase().replaceAll('-', '_')
      : value,
  assetFunctionalStatusSchema
);

// The scrapped functional status is a special case that should not be used in
// general asset functional status lists.
export const ASSET_FUNCTIONAL_STATUSES: AssetFunctionalStatus[] = [
  'FUNCTIONAL',
  'NEEDS_REVIEW',
  'NON_FUNCTIONAL',
];

export const ASSET_FUNCTIONAL_STATUS_LABELS: Record<
  AssetFunctionalStatus,
  string
> = {
  FUNCTIONAL: 'Okay',
  NEEDS_REVIEW: 'Pending',
  NON_FUNCTIONAL: 'Error',
  SCRAPPED: 'Scrapped',
};
